import type { OrderStatusFilter } from "@/components/orders/order-status-badge";

export type OrdersSearch = {
  status: OrderStatusFilter;
  search: string;
  page: number;
};

export const DEFAULT_ORDERS_SEARCH: OrdersSearch = {
  status: "all",
  search: "",
  page: 1,
};

export function parseOrdersSearch(
  search: Record<string, unknown>,
): OrdersSearch {
  return {
    status: isStatusFilter(search.status)
      ? search.status
      : DEFAULT_ORDERS_SEARCH.status,
    search:
      typeof search.search === "string"
        ? search.search
        : DEFAULT_ORDERS_SEARCH.search,
    page:
      typeof search.page === "number"
        ? search.page
        : Number(search.page) || DEFAULT_ORDERS_SEARCH.page,
  };
}

function isStatusFilter(value: unknown): value is OrderStatusFilter {
  return (
    value === "all" ||
    value === "pending" ||
    value === "confirmed" ||
    value === "processing" ||
    value === "shipped"
  );
}
